import { Stack, Form, FormButton, H1, FlexContainer, useField, H2, Button } from "@carrotfertility/carotene"
import { useCurrentUser } from "components/context/user/UserContext"
import { Body } from "components/views/atoms/Bodies"
import { CompleteFormTextArea } from "components/views/atoms/forms/FormTextArea"
import { IlloPaperAirplaneCircle } from "components/views/atoms/Illustrations"
import { Modal } from "components/views/modal/Modal"
import React from "react"
import { FormattedMessage } from "react-intl"
import { useHistory } from "react-router-dom"
import { adminCarrotClient } from "utils/CarrotClient"

function ConnectedTextArea(): JSX.Element {
  const { getInputProps } = useField("memberNote", {})
  return (
    <CompleteFormTextArea
      style={{ height: "240px" }}
      name="memberNote"
      label="message"
      {...(getInputProps() as Record<string, unknown>)}
    />
  )
}

function SaveCompleteView(): JSX.Element {
  const history = useHistory()
  return (
    <Modal titleText="Journey Complete Member Note Saved" showCloseButton={false}>
      <Stack padding="giant" spacing="large">
        <FlexContainer justifyContent="center">
          <IlloPaperAirplaneCircle />
        </FlexContainer>
        <Stack spacing="tiny">
          <H2>
            <FormattedMessage defaultMessage="Message received!" />
          </H2>
          <Body color="black-80">
            <FormattedMessage defaultMessage="Thanks for telling us about your experience." />
          </Body>
        </Stack>
      </Stack>
      <FlexContainer paddingLeftRight="medium" stack="medium" justifyContent="flex-end">
        <Button variant="primary" onClick={() => history.replace("/")}>
          <FormattedMessage defaultMessage="Close" />
        </Button>
      </FlexContainer>
    </Modal>
  )
}

export function JourneyCompleteNoteModal(): JSX.Element {
  const history = useHistory()
  const { getFirstName } = useCurrentUser()
  const [showCompleteView, setShowCompleteView] = React.useState(false)
  if (showCompleteView) {
    return <SaveCompleteView />
  }

  // @ts-expect-error TS7006
  const submitForm = async (form) => {
    try {
      await adminCarrotClient.carrotPlanJourneyCompleteMemberNote(form?.memberNote)
      setShowCompleteView(true)
    } catch (error) {
      reportError(error)
    }
  }
  return (
    <Modal titleText="Journey Complete Member Note" onExit={() => history.replace("/")}>
      <Form onSubmit={(form) => submitForm(form)}>
        <Stack paddingLeftRight="huge" spacing="large">
          <Stack spacing="tiny">
            <H1 variant="dark">
              <FormattedMessage
                defaultMessage="Thanks, {memberFirstName}"
                values={{ memberFirstName: getFirstName() }}
              />
            </H1>
            <Body color="black-60">
              <FormattedMessage defaultMessage="If you'd like, tell us why your journey with Carrot is complete. Were we able to help you with your goals?" />
            </Body>
          </Stack>
          <ConnectedTextArea />
        </Stack>
        <FlexContainer justifyContent="flex-end" padding="medium">
          <FormButton variant="primary">
            <FormattedMessage defaultMessage="Send" />
          </FormButton>
        </FlexContainer>
      </Form>
    </Modal>
  )
}
